import { PRODUCTS } from "./products";

//—— 搜尋頁內容 ——
//
//  之後接後端時，把 searchProducts 換成打 API 即可 —— 頁面吃的是這支的回傳，
//  資料形狀不變的話畫面一行都不用改。
//
//  目錄直接由 products.js 長出來。以前是把首頁那幾份清單攤平再去重 ——
//  同一個產品在輪播與卡片列是兩筆不同 id 的資料，不去重就會搜出兩張一樣的卡。
//  一支產品只有一筆之後，去重那段邏輯連同它的坑一起不需要了。

//推薦關鍵字：使用者不知道能搜什麼時的起點。
//  混「術種」與「白話問題」兩類 —— 只放術語會擋掉不懂命理的人。
//
//  ⚠️ 推薦的關鍵字一定要搜得到東西。2026-10-29 拿掉「流年」——
//  它只對得上判官（liunian-panguan），而那支還沒上架，
//  點下去是一片空的結果頁。推薦詞搜不到東西比沒有推薦詞更糟：
//  使用者會以為是整個搜尋壞了，而不是那一個詞沒有結果。
//  判官上架時再把它加回來（KEYWORD_MAP 裡那一組可以留著，
//  那是「有人自己打這個詞」時的對照，不是我們主動推薦的）。
export const RECOMMEND_KEYWORDS = ["八字", "紫微", "合盤", "卜卦", "感情"];

//額外的搜尋詞
//  只比對標題會漏掉大量意圖相同的說法：搜「分手」該找得到緋紅，
//  搜「問事」該找得到伏爻子。key 用產品 code，和後端的 productCode 同一組字。
const KEYWORD_MAP = {
  "bazi-baiye": [
    "八字",
    "命盤",
    "批命",
    "個性",
    "天賦",
    "五行",
    "日主",
    "十神",
    "大運",
  ],
  "ziwei-jingyue": [
    "紫微",
    "斗數",
    "命宮",
    "十二宮",
    "四化",
    "格局",
    "星曜",
    "大限",
  ],
  "match-feihong": [
    "合盤",
    "配對",
    "戀愛",
    "感情",
    "婚姻",
    "曖昧",
    "復合",
    "分手",
    "姻緣",
    "桃花",
    "魅力",
  ],
  "liuyao-fuyaozi": [
    "問卦",
    "卜卦",
    "六爻",
    "文王卦",
    "問事",
    "占卜",
    "易經",
    "卦象",
    "求籤",
  ],
  "liunian-panguan": ["流年", "今年", "明年", "年運", "運勢", "流月", "犯太歲"],
};

//可搜尋的目錄
//  角色名與術種一律納入關鍵字：使用者記得的往往是「那個蒙眼的仙子」，
//  而不是產品全名，搜「鏡月」和搜「紫微」都要找得到同一支。
const CATALOG = PRODUCTS.map((p) => ({
  id: p.id,
  glyph: p.glyph,
  theme: p.theme,
  image: p.image,
  title: p.persona.name,
  subtitle: p.subtitle,
  path: p.path,
  keywords: [p.persona.name, p.persona.craft, ...(KEYWORD_MAP[p.code] || [])],
}));

//即時熱門：寬版大卡，比一般卡片更能承載封面視覺。
//  先取前三支；之後接後端就換成真實的熱門排序。
export const TRENDING = CATALOG.slice(0, 3);

//搜尋
//  比對標題、副標與關鍵字，全部轉小寫再比 —— 使用者輸入英文時大小寫不該影響結果。
//  關鍵字為空則回空陣列（由頁面決定顯示推薦內容）。
export const searchProducts = (keyword) => {
  const kw = (keyword || "").trim().toLowerCase();
  if (!kw) return [];

  return CATALOG.filter((item) => {
    const haystack = [item.title, item.subtitle, ...(item.keywords || [])]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
};
